<template>
  <div class="body">
    <PageHeader></PageHeader>
    <div class="solt-wrapper">
      <slot />
    </div>
    <PageFooter></PageFooter>

    <!-- 返回顶部按钮 -->
    <el-backtop :right="100" :bottom="100">
      <div class="goback-wrapper">
        <img width="24" src="~/assets/images/top.png" alt="" />
        <span>回顶部</span>
      </div>
    </el-backtop>
  </div>
</template>
<script setup>
useHead({
  title: "ModuleMotion - 半导体基础系统供应商",
  meta: [
    {
      name: "description",
      content: "半导体能耗控制Box",
    },
    {
      name: "keywords",
      content: "常州微著,微著系统,半导体协议,SECS,GEM200,GEM300,网关设备",
    },
  ],
});
</script>
<style lang="scss" scoped>
.body {
  min-width: 1024px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.solt-wrapper {
  flex-grow: 1;
  flex-shrink: 1;
  min-height: calc(100vh - #{$headerHeight} - #{$footerHeight});
  // background-color: $uni-bg-color;
  & > * {
    min-height: calc(100vh - #{$headerHeight} - #{$footerHeight});
  }
}
:deep(.el-backtop) {
  border-radius: 0;
  box-shadow: none;
  width: 50px;
  height: 50px;
  background-color: none;
  border-radius: 8px;
  .goback-wrapper {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: $uni-text-color-tips;
    font-size: 12px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.12);
    background-color: #fff;
  }
}
</style>
